import type { TLogbookStatus } from "../../../pages/Home/Home.types";
import { useSearchParams } from "react-router-dom";
import { StyledStatusButton } from "../../../pages/Home/Home.styled";
import { titlecase } from "../../../utils";

const StatusButton = ({
  name,
  status,
  setStatus,
}: {
  name: TLogbookStatus;
  status: TLogbookStatus;
  setStatus: (status: TLogbookStatus) => void;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleSetStatus = () => {
    setSearchParams({ ...searchParams, lbtype: name });
    setStatus(name);
  };

  return (
    <StyledStatusButton
      className={
        status === name ? "status-btn-active status-btn" : "status-btn"
      }
      active={status === name}
      onClick={handleSetStatus}>
      {name === "active" ? "Subscribed" : titlecase(name)}
    </StyledStatusButton>
  );
};
export default StatusButton;
